// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './PortCompare.scss';
import Port from './Modules/Port';


// COMPONENT
export default function PortCompare (props) {
   // States and Variables
   const [devices, setDevices] = useState(null);
   const [fields, setFields] = useState(null);

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Port Compare");  // set page title
      getDevices();
      getFields();
   }, []);

   // Functions
   const getDevices = function () {
      OHSCRUD({
         url: '/v1/oneport/devices',
         method: 'GET',
         success: function (data) {
            setDevices(OHSListDataFormatter(data));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getFields = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'GET',
         success: function (data) {
            setFields(data);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }

   // Component
   return (
      <div className="oneport-portcompare">
         <OHSAppHeader onehive={props.onehive} title="Port Compare" help="https://www.onehivesystems.com/documentation/oneport/portcompare" />
         <OHSAppBody onehive={props.onehive}>
            <div className='oneport-portcompare-container'>
               <OHSWidget onehive={props.onehive} title="Port 1">
                  <Port onehive={props.onehive} parent={{
                     devices: devices,
                     fields: fields
                  }} />
               </OHSWidget>
               <OHSWidget onehive={props.onehive} title="Port 2">
                  <Port onehive={props.onehive} parent={{
                     devices: devices,
                     fields: fields
                  }} />
               </OHSWidget>
               <OHSWidget onehive={props.onehive} title="Port 3">
                  <Port onehive={props.onehive} parent={{
                     devices: devices,
                     fields: fields
                  }} />
               </OHSWidget>
            </div>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}